// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"7893":"9afd1bb7","8680":"fe581f21"}[chunkId] + ".css";
};